import { useState } from "react";

export const useToast = () => {
    const initialToast = {
        status: "success",
        show: false,
        message: "",
    };
    const [toast, setToast] = useState(initialToast);

    const reset = () => {
        setToast(initialToast);
    };

    return {
        toast,
        setToast,
        reset,
    };
};
